// Purdue's undergraduate majors (#2743). Read on 2026-10-01 from the official
// 2026-2027 University Catalog's Undergraduate Programs List
// (catalog.purdue.edu, catoid=19, navoid=25484), which lists every program
// under its college and department with the degree it awards. Every
// bachelor's line is kept, with concentrations ("Agronomy: Crop and Soil
// Management Concentration, BS"), tracks ("French, BA (Language & Culture
// Track)") and the Data Science and Interdisciplinary Science department
// variants folded into one major per degree. Minors, certificates,
// pre-programs, associate degrees and graduate programs are left out; the
// Honors College, Exploratory Studies and the Libraries list no bachelor's
// major. Majors the catalog marks "(Indianapolis Only)" or "(Statewide)"
// carry that as a note. Degree abbreviations are the catalog's own (BS,
// BSAGE, BSCMPE, BSFOR, ...). "Women's" is typed with a straight apostrophe.
// Artificial Intelligence (BA and BS) is the catalog's official major name.
// The KB's majors list was the starting point; the catalog wins.
const majors = {
    "slug": "purdue-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in Purdue's official 2026-2027 University Catalog, grouped by the college that offers it, with the degree it leads to. Concentrations and tracks are folded into their major, and minors, certificates, pre-programs and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Agriculture",
            "source": {
                "label": "Purdue 2026-2027 University Catalog, Undergraduate Programs List",
                "url": "https://catalog.purdue.edu/content.php?catoid=19&navoid=25484"
            },
            "majors": [
                {
                    "name": "Natural Resources and Environmental Science",
                    "degree": "BS"
                },
                {
                    "name": "Agricultural Systems Management",
                    "degree": "BS"
                },
                {
                    "name": "Agricultural Engineering",
                    "degree": "BSAGE"
                },
                {
                    "name": "Environmental and Natural Resources Engineering",
                    "degree": "BSAGE"
                },
                {
                    "name": "Biological Engineering",
                    "degree": "BSBE"
                },
                {
                    "name": "Agribusiness",
                    "degree": "BS"
                },
                {
                    "name": "Agricultural Economics",
                    "degree": "BS"
                },
                {
                    "name": "Farm Management",
                    "degree": "BS"
                },
                {
                    "name": "Sales and Marketing",
                    "degree": "BS"
                },
                {
                    "name": "Agricultural Education",
                    "degree": "BS"
                },
                {
                    "name": "Agronomy",
                    "degree": "BS"
                },
                {
                    "name": "Crop Science",
                    "degree": "BS"
                },
                {
                    "name": "Digital Agronomy",
                    "degree": "BS"
                },
                {
                    "name": "Plant Genetics, Breeding, and Biotechnology",
                    "degree": "BS"
                },
                {
                    "name": "Soil and Water Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Animal Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BS"
                },
                {
                    "name": "Plant Science",
                    "degree": "BS"
                },
                {
                    "name": "Insect Biology",
                    "degree": "BS"
                },
                {
                    "name": "Fermentation Science",
                    "degree": "BS"
                },
                {
                    "name": "Food Science",
                    "degree": "BS"
                },
                {
                    "name": "Aquatic Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Wildlife",
                    "degree": "BS"
                },
                {
                    "name": "Forestry",
                    "degree": "BSFOR"
                },
                {
                    "name": "Horticulture",
                    "degree": "BS"
                },
                {
                    "name": "Sustainable Food and Farming Systems",
                    "degree": "BS"
                },
                {
                    "name": "Turf Management and Science",
                    "degree": "BS"
                },
                {
                    "name": "Landscape Architecture",
                    "degree": "BSLA"
                }
            ]
        },
        {
            "name": "Mitch Daniels School of Business",
            "source": {
                "label": "Purdue 2026-2027 University Catalog, Undergraduate Programs List",
                "url": "https://catalog.purdue.edu/content.php?catoid=19&navoid=25484"
            },
            "majors": [
                {
                    "name": "Integrated Business & Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Accounting",
                    "degree": "BS"
                },
                {
                    "name": "Economics",
                    "degree": "BS"
                },
                {
                    "name": "Quantitative Business Economics",
                    "degree": "BS"
                },
                {
                    "name": "Finance",
                    "degree": "BS"
                },
                {
                    "name": "Business Analytics and Information Management",
                    "degree": "BS"
                },
                {
                    "name": "Marketing",
                    "degree": "BS"
                },
                {
                    "name": "Organizational Behavior & Human Resource Management",
                    "degree": "BS"
                },
                {
                    "name": "General Management",
                    "degree": "BS"
                },
                {
                    "name": "Supply Chain & Operations Management",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Education",
            "source": {
                "label": "Purdue 2026-2027 University Catalog, Undergraduate Programs List",
                "url": "https://catalog.purdue.edu/content.php?catoid=19&navoid=25484"
            },
            "majors": [
                {
                    "name": "Elementary Education",
                    "degree": "BA"
                },
                {
                    "name": "English Education",
                    "degree": "BA"
                },
                {
                    "name": "General Education",
                    "degree": "BA"
                },
                {
                    "name": "Social Studies Education",
                    "degree": "BA"
                },
                {
                    "name": "Special Education Mild and Intense Intervention P to 12",
                    "degree": "BA"
                },
                {
                    "name": "Special Education/Elementary Education",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "College of Engineering",
            "source": {
                "label": "Purdue 2026-2027 University Catalog, Undergraduate Programs List",
                "url": "https://catalog.purdue.edu/content.php?catoid=19&navoid=25484"
            },
            "majors": [
                {
                    "name": "Aeronautical and Astronautical Engineering",
                    "degree": "BSAAE"
                },
                {
                    "name": "Biomedical Engineering",
                    "degree": "BSBME"
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "BSCHE"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "BSCE"
                },
                {
                    "name": "Construction Engineering",
                    "degree": "BSCNE"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "BSCMPE"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "BSEE"
                },
                {
                    "name": "Interdisciplinary Engineering Studies",
                    "degree": "BS"
                },
                {
                    "name": "Multidisciplinary Engineering",
                    "degree": "BSE"
                },
                {
                    "name": "Environmental and Ecological Engineering",
                    "degree": "BSEEE"
                },
                {
                    "name": "Industrial Engineering",
                    "degree": "BSIE"
                },
                {
                    "name": "Materials Engineering",
                    "degree": "BSMSE"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BSME"
                },
                {
                    "name": "Motorsports Engineering",
                    "degree": "BSMSPE",
                    "note": "Offered in Indianapolis only."
                },
                {
                    "name": "Nuclear Engineering",
                    "degree": "BSNE"
                }
            ]
        },
        {
            "name": "College of Health and Human Sciences",
            "source": {
                "label": "Purdue 2026-2027 University Catalog, Undergraduate Programs List",
                "url": "https://catalog.purdue.edu/content.php?catoid=19&navoid=25484"
            },
            "majors": [
                {
                    "name": "Kinesiology",
                    "degree": "BS"
                },
                {
                    "name": "Biomedical Health Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Medical Laboratory Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Occupational and Environmental Health Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Radiological Health Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Financial Counseling and Planning",
                    "degree": "BS"
                },
                {
                    "name": "Hospitality and Tourism Management",
                    "degree": "BS"
                },
                {
                    "name": "Retail Management",
                    "degree": "BS"
                },
                {
                    "name": "Selling and Sales Management",
                    "degree": "BS"
                },
                {
                    "name": "Developmental and Family Science",
                    "degree": "BS"
                },
                {
                    "name": "Early Childhood Education and Exceptional Needs",
                    "degree": "BS"
                },
                {
                    "name": "Family and Consumer Sciences Education",
                    "degree": "BS"
                },
                {
                    "name": "Human Services",
                    "degree": "BS"
                },
                {
                    "name": "Accelerated Nursing",
                    "degree": "BSN"
                },
                {
                    "name": "Nursing",
                    "degree": "BSN"
                },
                {
                    "name": "Dietetics/Nutrition, Fitness and Health",
                    "degree": "BS"
                },
                {
                    "name": "Nutrition and Dietetics",
                    "degree": "BS"
                },
                {
                    "name": "Nutrition Science",
                    "degree": "BS"
                },
                {
                    "name": "Nutrition, Fitness, and Health",
                    "degree": "BS"
                },
                {
                    "name": "Brain and Behavioral Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Psychological Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Public Health",
                    "degree": "BS"
                },
                {
                    "name": "Speech, Language, and Hearing Sciences",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Liberal Arts",
            "source": {
                "label": "Purdue 2026-2027 University Catalog, Undergraduate Programs List",
                "url": "https://catalog.purdue.edu/content.php?catoid=19&navoid=25484"
            },
            "majors": [
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "Anthropology Honors",
                    "degree": "BA"
                },
                {
                    "name": "Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Anthropology",
                    "degree": "BS"
                },
                {
                    "name": "Communication",
                    "degree": "BA"
                },
                {
                    "name": "Creative Writing",
                    "degree": "BA"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "Professional Writing",
                    "degree": "BA"
                },
                {
                    "name": "History Honors",
                    "degree": "BA"
                },
                {
                    "name": "History of Science, Technology, and Medicine",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "African American Studies",
                    "degree": "BA"
                },
                {
                    "name": "American Studies",
                    "degree": "BA"
                },
                {
                    "name": "Global Studies",
                    "degree": "BA"
                },
                {
                    "name": "Jewish Studies",
                    "degree": "BA"
                },
                {
                    "name": "Linguistics",
                    "degree": "BA"
                },
                {
                    "name": "Religious Studies",
                    "degree": "BA"
                },
                {
                    "name": "Women's, Gender & Sexuality Studies",
                    "degree": "BA"
                },
                {
                    "name": "Asian Studies",
                    "degree": "BA"
                },
                {
                    "name": "Chinese Studies",
                    "degree": "BA"
                },
                {
                    "name": "Classical Studies",
                    "degree": "BA"
                },
                {
                    "name": "Comparative Literature",
                    "degree": "BA"
                },
                {
                    "name": "French",
                    "degree": "BA"
                },
                {
                    "name": "German",
                    "degree": "BA"
                },
                {
                    "name": "Italian Studies",
                    "degree": "BA"
                },
                {
                    "name": "Japanese",
                    "degree": "BA"
                },
                {
                    "name": "Russian",
                    "degree": "BA"
                },
                {
                    "name": "Spanish",
                    "degree": "BA"
                },
                {
                    "name": "Artificial Intelligence",
                    "degree": "BA"
                },
                {
                    "name": "Cognitive Science",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Law and Society",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Digital Criminology",
                    "degree": "BS"
                },
                {
                    "name": "Design Studies",
                    "degree": "BA"
                },
                {
                    "name": "Film & Video",
                    "degree": "BA"
                },
                {
                    "name": "Interdisciplinary Performance",
                    "degree": "BA"
                },
                {
                    "name": "Music",
                    "degree": "BA"
                },
                {
                    "name": "Sound for the Performing Arts",
                    "degree": "BA"
                },
                {
                    "name": "Studio Arts and Technology",
                    "degree": "BA"
                },
                {
                    "name": "Theatre",
                    "degree": "BA"
                },
                {
                    "name": "Visual Arts Design Education",
                    "degree": "BA"
                },
                {
                    "name": "Visual Arts Education",
                    "degree": "BA"
                },
                {
                    "name": "Industrial Design Professional Program",
                    "degree": "BFA"
                },
                {
                    "name": "Integrated Studio Arts",
                    "degree": "BFA"
                },
                {
                    "name": "Interior Design Professional Program",
                    "degree": "BFA"
                },
                {
                    "name": "Visual Communication Design",
                    "degree": "BFA"
                }
            ]
        },
        {
            "name": "College of Pharmacy",
            "source": {
                "label": "Purdue 2026-2027 University Catalog, Undergraduate Programs List",
                "url": "https://catalog.purdue.edu/content.php?catoid=19&navoid=25484"
            },
            "majors": [
                {
                    "name": "Pharmaceutical Sciences",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Polytechnic Institute",
            "source": {
                "label": "Purdue 2026-2027 University Catalog, Undergraduate Programs List",
                "url": "https://catalog.purdue.edu/content.php?catoid=19&navoid=25484"
            },
            "majors": [
                {
                    "name": "Multidisciplinary Technology",
                    "degree": "BS"
                },
                {
                    "name": "Animation And Visual Effects",
                    "degree": "BS"
                },
                {
                    "name": "Computer and Information Technology",
                    "degree": "BS"
                },
                {
                    "name": "Computing Infrastructure and Network Engineering Technology",
                    "degree": "BS"
                },
                {
                    "name": "Cybersecurity",
                    "degree": "BS"
                },
                {
                    "name": "Data Analytics, Technologies, and Applications",
                    "degree": "BS"
                },
                {
                    "name": "Game Development",
                    "degree": "BS"
                },
                {
                    "name": "Themed Entertainment Design",
                    "degree": "BS",
                    "note": "Offered in Indianapolis only."
                },
                {
                    "name": "UX Design",
                    "degree": "BS"
                },
                {
                    "name": "Web Programming & Design",
                    "degree": "BS"
                },
                {
                    "name": "Aeronautical Engineering Technology",
                    "degree": "BS"
                },
                {
                    "name": "Aeronautical Technology",
                    "degree": "BS",
                    "note": "Offered at Polytechnic Statewide locations."
                },
                {
                    "name": "Aviation Management",
                    "degree": "BS"
                },
                {
                    "name": "Professional Flight Technology",
                    "degree": "BS"
                },
                {
                    "name": "Unmanned Aerial Systems",
                    "degree": "BS"
                },
                {
                    "name": "Building Information Modeling",
                    "degree": "BS"
                },
                {
                    "name": "Construction Management",
                    "degree": "BS"
                },
                {
                    "name": "Design and Construction Integration",
                    "degree": "BS"
                },
                {
                    "name": "Interior Architecture",
                    "degree": "BS",
                    "note": "Offered in Indianapolis only."
                },
                {
                    "name": "Audio Engineering Technology",
                    "degree": "BS"
                },
                {
                    "name": "Computer Engineering Technology",
                    "degree": "BS"
                },
                {
                    "name": "Digital Enterprise Systems",
                    "degree": "BS"
                },
                {
                    "name": "Electrical Engineering Technology",
                    "degree": "BS"
                },
                {
                    "name": "Engineering Technology",
                    "degree": "BS",
                    "note": "Offered at Polytechnic Statewide locations."
                },
                {
                    "name": "Industrial Engineering Technology",
                    "degree": "BS"
                },
                {
                    "name": "Mechanical Engineering Technology",
                    "degree": "BS"
                },
                {
                    "name": "Mechatronics Engineering Technology",
                    "degree": "BS"
                },
                {
                    "name": "Robotics Engineering Technology",
                    "degree": "BS"
                },
                {
                    "name": "Smart Manufacturing Industrial Informatics",
                    "degree": "BS"
                },
                {
                    "name": "Supply Chain & Sales Engineering Technology",
                    "degree": "BS"
                },
                {
                    "name": "Engineering Technology Education",
                    "degree": "BS"
                },
                {
                    "name": "Human Resource Development",
                    "degree": "BS"
                },
                {
                    "name": "Organizational Leadership",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Science",
            "source": {
                "label": "Purdue 2026-2027 University Catalog, Undergraduate Programs List",
                "url": "https://catalog.purdue.edu/content.php?catoid=19&navoid=25484"
            },
            "majors": [
                {
                    "name": "Biomolecular Design",
                    "degree": "BS"
                },
                {
                    "name": "Interdisciplinary Science",
                    "degree": "BS"
                },
                {
                    "name": "Science Education",
                    "degree": "BS"
                },
                {
                    "name": "Biology",
                    "degree": "BS"
                },
                {
                    "name": "Cell, Molecular, and Developmental Biology",
                    "degree": "BS"
                },
                {
                    "name": "Chemical Biology & Biochemistry",
                    "degree": "BS"
                },
                {
                    "name": "Ecology, Evolution, and Environmental Biology",
                    "degree": "BS"
                },
                {
                    "name": "Genetics",
                    "degree": "BS"
                },
                {
                    "name": "Health and Disease",
                    "degree": "BS"
                },
                {
                    "name": "Neurobiology and Physiology",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Biochemistry (Chemistry)",
                    "degree": "BSCH"
                },
                {
                    "name": "Chemistry (ACS)",
                    "degree": "BSCH"
                },
                {
                    "name": "Artificial Intelligence",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science Honors",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Data Science",
                    "degree": "BS"
                },
                {
                    "name": "Atmospheric Science",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Geoscience",
                    "degree": "BS"
                },
                {
                    "name": "Geology and Geophysics",
                    "degree": "BS"
                },
                {
                    "name": "Planetary Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Actuarial Science Honors",
                    "degree": "BS"
                },
                {
                    "name": "Actuarial Science",
                    "degree": "BS"
                },
                {
                    "name": "Applied Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics Education",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics Honors",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics/Business",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics/Statistics",
                    "degree": "BS"
                },
                {
                    "name": "Applied Physics Honors",
                    "degree": "BS"
                },
                {
                    "name": "Applied Physics",
                    "degree": "BS"
                },
                {
                    "name": "Astrophysics",
                    "degree": "BS"
                },
                {
                    "name": "Physics Honors",
                    "degree": "BS"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Applied Statistics",
                    "degree": "BS"
                },
                {
                    "name": "Integrated Science and Business - Applied Statistics",
                    "degree": "BS"
                },
                {
                    "name": "Statistics Honors",
                    "degree": "BS"
                },
                {
                    "name": "Statistics",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Veterinary Medicine",
            "source": {
                "label": "Purdue 2026-2027 University Catalog, Undergraduate Programs List",
                "url": "https://catalog.purdue.edu/content.php?catoid=19&navoid=25484"
            },
            "majors": [
                {
                    "name": "Veterinary Nursing",
                    "degree": "BSVN"
                }
            ]
        }
    ]
};

export default majors;
